var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLegWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 317.503,
    height: 687.607,
    viewBox: "0.001 0 317.503 687.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "CompositeLayer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.616 165.619c2.468-.303 5.743 2.153 7.435 4.307 2.98 3.79 3.231 9.413-.112 10.437-2.524.774-6.522-1.251-8.637-3.743-3.614-4.257-2.304-10.557 1.314-11.001",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.615 153.003c3.728.704 7.03 5.632 7.98 9.244 1.179 4.481-.464 9.985-4.594 9.942-4.027-.04-9.131-5.337-10.168-9.952-1.144-5.092 2.517-10.038 6.782-9.234",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.253 145.68c4.555.96 8.248 8.262 8.636 13.263.123 1.584.488 6.287-3.173 7.546-2.422.832-5.615-.184-7.763-1.559-4.682-2.994-5.941-8.673-5.356-12.204.615-3.708 3.74-7.871 7.656-7.047",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.922 143.788c4.719 1.392 8.183 8.307 8.636 13.263.397 4.353-1.21 10.681-5.797 10.505-4.47-.17-9.526-6.419-11.153-11.221-1.624-4.794-.56-10.318 3.72-12.126.817-.346 2.475-1.047 4.594-.421",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15 144.017c6.018 1.017 12.142 10 13.884 16.865 1.667 6.565.616 16.273-6.564 16.92-6.334.576-14.623-6.15-17.822-12.423-5.481-10.749 2.714-22.676 10.502-21.362",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.095.494c-6.636-2.212-12.347 3.473-14.545 7.677-3.565 6.823-2.45 18.485 4.15 22.29 5.776 3.33 13.915-.413 17.606-4.784 3.404-4.028 5.101-11.044.99-17.773-.778-1.271-3.59-5.874-8.2-7.41",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.631 18.285c-4.746-2.197-11.69 2.214-12.357 8.383-.471 4.358 2.056 10.805 6.448 12.56 4.713 1.882 9.751-2.368 11.046-6.905 1.37-4.807-.852-12.053-5.137-14.038",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.87 56.12c2.068-10.99 16.272-15.812 27.997-15.709 22.21.2 40.1 18.113 40.894 18.928 17.716 18.197 17.304 41.478 9.611 52.62-1.04 1.506-3.719 4.152-9.077 9.443-11.966 11.816-14.01 11.574-17.938 17.057-1.756 2.451-3.966 9.024-8.315 22.068-5.518 16.552-5.56 18.04-8.206 21.152-2.17 2.558-9.06 10.666-22.858 10.706-2.138.005-18.874.053-29.303-11.374-8.493-9.307-8.218-21.203-4.587-28.144 4.555-8.704 12.384-5.775 27.014-16.978 7.494-5.738 12.97-9.932 14.656-18.116 2.235-10.835-3.46-22.429-4.915-25.392-4.481-9.123-8.617-11.261-12.243-21.095-1.773-4.812-3.696-10.028-2.73-15.165",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.19 68.527c-3.265-2.119-9.32-.07-10.717 4.154-.89 2.686-.103 6.882 2.403 8.393 3.47 2.093 10.398-.86 10.936-5.987.201-1.907-.377-5.105-2.622-6.56",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.025 49.054c-3.771-1.738-9.032 1.677-9.843 6.34-.716 4.114 1.89 9.99 5.464 11.29 3.904 1.414 8.395-2.828 8.86-7.612.327-3.365-1.191-8.502-4.481-10.018",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.234 32.545c-4.07-1.95-10.508 2.065-11.155 7.82-.457 4.069 1.88 9.87 5.466 11.29 4.16 1.646 9.355-2.873 10.062-8.177.49-3.693-.99-9.312-4.373-10.933",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.039 394.498c-1.884-.948-5.57 4.182-5.747 10.689-.215 7.778 4.702 13.225 6.593 11.967 2.834-1.887 2.253-21.095-.846-22.656",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.013 238.655c2.017 4.68-2.556 18.903-6.995 18.393-2.366-.27-4.998-4.761-4.969-9.604.028-4.368 2.21-7.137 2.78-7.86 2.953-3.749 7.804-4.132 9.184-.929",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.791 577.264c2.646.737 9.532 3.33 9.467 6.623-.067 3.385-7.473 8.373-12.152 3.756-2.416-2.384-4.271-7.496-3.437-9.76.774-2.107 3.704-1.292 6.122-.619",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18 174.68c4.415 1.211 22.765 6.237 32.69 21.04 1.195 1.78 7.486 11.485 5.464 20.806-1.147 5.287-4.157 6.73-13.126 14.802-11.389 10.255-17.083 15.382-18.374 20.724-2.632 10.883 4.047 22.853 6.883 27.932 8.31 14.893 16.557 15.975 21.535 28.86 1.296 3.352 5.6 14.494-.442 22.709-.477.65-6.12 7.984-17.936 7.535-16.334-.623-29.204-15.546-29.849-16.312-4.458-5.302-6.792-6.595-10.598-34.847-3.85-28.555-3.364-29.945-5.788-37.1-6.82-20.121-15.01-24.204-17.925-40.07-.672-3.655-3.72-20.232 8.208-30.674 13.778-12.063 36.403-6.186 39.257-5.405",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.932 352.35c-3.265-2.12-9.32-.071-10.717 4.153-.89 2.686-.103 6.883 2.403 8.394 3.469 2.093 10.398-.86 10.936-5.988.201-1.906-.377-5.104-2.622-6.56",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.767 332.877c-3.771-1.738-9.032 1.677-9.843 6.34-.716 4.114 1.89 9.99 5.464 11.289 3.903 1.415 8.395-2.827 8.86-7.612.327-3.364-1.192-8.502-4.481-10.017",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.976 316.365c-4.07-1.95-10.508 2.065-11.155 7.82-.457 4.069 1.88 9.87 5.466 11.29 4.16 1.646 9.355-2.873 10.062-8.175.49-3.695-.99-9.314-4.373-10.935",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.373 302.108c-4.746-2.197-11.69 2.214-12.358 8.383-.47 4.358 2.057 10.804 6.45 12.56 4.712 1.881 9.75-2.369 11.045-6.906 1.37-4.807-.852-12.053-5.137-14.037",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.837 284.317c-6.636-2.212-12.347 3.473-14.545 7.677-3.565 6.822-2.45 18.484 4.15 22.29 5.776 3.33 13.915-.414 17.606-4.784 3.403-4.028 5.101-11.044.99-17.773-.778-1.271-3.59-5.874-8.2-7.41",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.457 514.117c2.467-.303 5.743 2.154 7.435 4.308 2.98 3.79 3.231 9.412-.112 10.436-2.524.774-6.523-1.251-8.638-3.743-3.613-4.257-2.303-10.557 1.315-11.001",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.456 501.502c3.728.703 7.03 5.631 7.98 9.243 1.179 4.482-.464 9.985-4.594 9.942-4.027-.04-9.131-5.337-10.168-9.952-1.144-5.092 2.517-10.038 6.782-9.233",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.094 494.177c4.555.961 8.248 8.263 8.636 13.264.123 1.584.488 6.287-3.173 7.546-2.422.832-5.615-.184-7.763-1.559-4.682-2.993-5.942-8.673-5.356-12.204.615-3.707 3.74-7.871 7.656-7.047",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.763 492.286c4.719 1.392 8.183 8.308 8.636 13.263.397 4.354-1.21 10.681-5.797 10.505-4.47-.17-9.526-6.419-11.153-11.22-1.624-4.795-.56-10.319 3.72-12.127.817-.345 2.474-1.047 4.594-.421",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.99 492.515c6.019 1.017 12.143 10 13.885 16.865 1.667 6.565.616 16.273-6.564 16.924-6.334.572-14.623-6.154-17.822-12.427-5.482-10.749 2.714-22.676 10.502-21.362",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.02 523.179c4.416 1.21 22.765 6.237 32.691 21.039 1.195 1.78 7.486 11.485 5.464 20.807-1.147 5.286-4.157 6.729-13.126 14.802-11.389 10.254-17.083 15.382-18.374 20.723-2.632 10.883 4.047 22.853 6.883 27.932 8.31 14.893 16.557 15.975 21.535 28.86 1.296 3.352 5.6 14.495-.442 22.709-.477.65-6.12 7.985-17.936 7.536-16.334-.623-29.205-15.546-29.849-16.313-4.458-5.301-6.792-6.595-10.599-34.847-3.849-28.555-3.363-29.945-5.788-37.1-6.82-20.12-15.01-24.204-17.925-40.07-.671-3.655-3.719-20.232 8.208-30.674 13.779-12.063 36.404-6.186 39.258-5.404",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.612 339.943c2.068-10.99 16.272-15.813 27.998-15.71 22.209.2 40.098 18.114 40.893 18.929 17.716 18.196 17.304 41.477 9.611 52.62-1.04 1.505-3.719 4.151-9.077 9.442-11.966 11.816-14.01 11.574-17.938 17.057-1.756 2.452-3.966 9.024-8.315 22.068-5.518 16.552-5.561 18.04-8.207 21.153-2.17 2.557-9.059 10.666-22.857 10.706-2.138.005-18.874.053-29.303-11.375-8.493-9.306-8.218-21.203-4.587-28.143 4.555-8.704 12.384-5.776 27.014-16.979 7.494-5.738 12.97-9.932 14.656-18.116 2.235-10.835-3.46-22.429-4.915-25.392-4.481-9.122-8.617-11.26-12.243-21.094-1.773-4.812-3.696-10.028-2.73-15.166",
    fill: "#41bbe8",
    fillRule: "evenodd",
    "data-name": "Path 59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLegWork);
export default __webpack_public_path__ + "static/media/homeLegWork.a8f857327193ae29b28ebcd660f48432.svg";
export { ForwardRef as ReactComponent };